import { stringify } from "query-string"

import { apiInstance } from "./api"

const endpoint = "/account"

export const signin = async data => {
  const { dhFoodsAuth } = apiInstance()

  const response = await dhFoodsAuth.post(`${endpoint}/login/mobilePhone`, data)

  return response.data
}

export const getOtpForMobile = async data => {
  const { dhFoodsAuth } = apiInstance()

  const response = await dhFoodsAuth.post(`${endpoint}/otp/mobilePhone`, data)

  return response.data
}

export const confirmOtp = async data => {
  const { dhFoodsAuth } = apiInstance()

  const response = await dhFoodsAuth.post(`${endpoint}/otp/confirm`, data)

  return response.data
}

export const getUserAccountInfo = async (queries) => {
  const { dhFoodsAuth } = apiInstance()

  const query = stringify(queries, {
    skipEmptyString: true,
    skipNull: true
  })

  const response = await dhFoodsAuth.get(`${endpoint}/info?${query}`)

  return response.data
}

export const editUserAccountInfo = async () => {
  const { dhFoodsAuth } = apiInstance()

  const response = await dhFoodsAuth.patch(`${endpoint}/info`)

  return response.data
}

export const getUserList = async queries => {
  const { dhFoodsAuth } = apiInstance()

  const query =
    stringify(queries, {
      skipEmptyString: true,
      skipNull: true
    })

  const response = await dhFoodsAuth.get(`${endpoint}/userList?${query}`)

  return response.data
}

export const getOnlyUserList = async queries => {
  const { dhFoodsAuth } = apiInstance()

  const query =
    stringify(queries, {
      skipEmptyString: true,
      skipNull: true
    })

  const response = await dhFoodsAuth.get(`${endpoint}/userList/onlyUsers?${query}`)

  return response.data
}

export const addUser = async data => {
  const { dhFoodsAuth } = apiInstance()

  const response = await dhFoodsAuth.post(`${endpoint}/user/user/add`, data)

  return response.data
}

export const getAccountBalanceReport = async () => {
  const { dhFoodsAuth } = apiInstance()

  const response = await dhFoodsAuth.get(`${endpoint}/report/balance`)

  return response.data
}

export const userLogoutRefreshToken = async () => {
  const { dhFoodsAuth } = apiInstance()

  const refreshToken =
    localStorage.getItem("rt")

  if (!refreshToken) return

  const response = await dhFoodsAuth.post(
    `${endpoint}/logout`,
    { refreshToken }
  )

  return response.data
}

export const refreshAccessToken = async () => {
  const { dhFoodsAuth } = apiInstance()

  const response =
    await dhFoodsAuth.post(
      `${endpoint}/refresh/token`,
      { refreshToken: localStorage.getItem("rt") }
    )

  return response.data
}